// Meta (Facebook) Pixel integration.
// Loads the pixel once, fires PageView on init, and exposes helpers for
// custom events such as AddToCart.

const PIXEL_ID = '1380891019689413'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      loaded?: boolean
      version?: string
      push?: unknown
    }
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code (once) and fires the initial PageView.
 * Safe to call multiple times — it only runs the setup a single time.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* eslint-disable */
  // Standard Meta Pixel base snippet, adapted to load fbevents.js.
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires the AddToCart standard event. */
export function trackAddToCart(): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart')
}
